import React, { useState } from 'react';
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, NavLink, useLocation } from 'react-router-dom';
import YourLogo from '../../Assets/Images/Pro_Logo.png';
import '../../Assets/Style/style.css';
import './sidebar.css';
import { RxHamburgerMenu } from 'react-icons/rx';
import { AiOutlineStock, AiOutlineBulb } from 'react-icons/ai';
import { TbFileInvoice, TbRepeat, TbTruckDelivery, TbUpload } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { getCompany } from '../../../Redux/selecters';
import { MdCancel, MdOutlineUndo } from 'react-icons/md';
import { FcApproval } from 'react-icons/fc';
import { FaMailBulk, FaFileInvoice, FaFileInvoiceDollar } from 'react-icons/fa';
import { BiWindowClose } from 'react-icons/bi';
import { IoReceiptOutline } from 'react-icons/io5';
import { CiCircleChevLeft, CiCircleChevRight } from 'react-icons/ci';
import { MdOutlineInventory } from 'react-icons/md';
import { BsFillPostcardFill } from 'react-icons/bs';

const PMSideBar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const companies = useSelector(getCompany);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };
  const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
  const accessibleForms = storedPermissions.filter((form) => form.canView);
  const [permissions, setPermission] = useState(accessibleForms);
  return (
    <div>
      <ProSidebar collapsed={collapsed}>
        {collapsed ? (
          // <a href="/" className="navbar-brand start">
          //   <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '40px', paddingTop: '8px', paddingBottom: '8px' }} />
          // </a>
          ''
        ) : (
          <a href="/" className="navbar-brand start">
            <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '75px' }} />
          </a>
        )}
        <Menu className="mt-2">
          {/* Dashboard */}
          {permissions?.some((p) => p.formName === 'Dashboard' && p.canView) && (
            <MenuItem icon={<AiOutlineStock size={22} />} active={location.pathname === '/'}>
              <NavLink to="/">Dashboard</NavLink>
            </MenuItem>
          )}

          {/* Lease Section */}
          <SubMenu icon={<BsFillPostcardFill size={22} />} title="Lease">
            {permissions?.some((p) => (p.formName === 'Lease Proposal' || p.formName === 'Lease Revenue') && p.canView) && (
              <MenuItem icon={<TbUpload size={18} />}>
                <NavLink to="/Property/Management/Lease/Proposal/Listing">Lease Proposal</NavLink>
              </MenuItem>
            )}

            {permissions?.some((p) => (p.formName === 'Proposal Approval' || p.formName === 'Lease Approval') && p.canView) && (
              <MenuItem icon={<FcApproval size={18} />}>
                <NavLink to="/Property/Management/Proposal/Approval">Proposal Approval</NavLink>
              </MenuItem>
            )}

            {permissions?.some((p) => p.formName === 'Lease Agreement ' && p.canView) && (
              <MenuItem icon={<AiOutlineBulb size={18} />}>
                <NavLink to="/Property/Management/LeaseAgreement">Lease Agreement</NavLink>
              </MenuItem>
            )}

            {permissions?.some((p) => p.formName === 'Lease Approval' && p.canView) && (
              <MenuItem icon={<FcApproval size={18} />}>
                <NavLink to="/Property/Management/Approval">Agreement Approval</NavLink>
              </MenuItem>
            )}

            {permissions?.some((p) => p.formName === 'Termination' && p.canView) && (
              <MenuItem icon={<MdCancel size={18} />}>
                <NavLink to="/Property/Management/Lease/Termination/Listing">Lease Termination</NavLink>
              </MenuItem>
            )}

          </SubMenu>

          {/* Invoices */}
          <SubMenu icon={<FaFileInvoiceDollar size={22} />} title="Invoices">
            {permissions?.some((p) => p.formName === 'Single Invoice' && p.canView) && (
              <MenuItem icon={<TbFileInvoice size={18} />}>
                <NavLink to="/Property/Management/Single/Invoice/Listing">Single Invoice</NavLink>
              </MenuItem>
            )}

            {permissions?.some((p) => p.formName === 'Installment Invoice' && p.canView) && (
              <MenuItem icon={<FaFileInvoiceDollar size={18} />}>
                <NavLink to="/Property/Management/Installment/Invoice/Listing">Installment Invoice</NavLink>
              </MenuItem>
            )}

            <MenuItem icon={<FaFileInvoice size={18} />}>
              <NavLink to="/Property/Management/Invoice/Approval">Invoice Approval</NavLink>
            </MenuItem>

            {permissions?.some((p) => p.formName === 'Lease General Invoice' && p.canView) && (
              <MenuItem icon={<BiWindowClose size={18} />}>
                <NavLink to="/Property/Management/Lease/GeneralInvoice/listing">Lease General Invoice</NavLink>
              </MenuItem>
            )}
          </SubMenu>

          {/* Receipts */}
          <SubMenu icon={<IoReceiptOutline size={22} />} title="Receipts">
            {/* {permissions?.some((p) => p.formName === 'Lease Receipt' && p.canView) && (
              <MenuItem icon={<FaFileInvoice size={18} />}>
                <NavLink to="/Property/Management/Lease/Receipt/Listing">Lease Receipt</NavLink>
              </MenuItem>
            )} */}

            {permissions?.some((p) => p.formName === 'Lease Bulk Receipt' && p.canView) && (
              <MenuItem icon={<FaMailBulk size={18} />}>
                <NavLink to="/Property/Management/Lease/Bulk/Receipt/Listing">Lease Bulk Receipt</NavLink>
              </MenuItem>
            )}

            {permissions?.some((p) => p.formName === 'Lease Reverse Receipt' && p.canView) && (
              <MenuItem icon={<MdOutlineUndo size={18} />}>
                <NavLink to="/Property/Management/Lease/Reverse/Receipt">Lease Reverse Receipt</NavLink>
              </MenuItem>
            )}
          </SubMenu>

          {/* Posting & Revenue */}
          <SubMenu icon={<TbRepeat size={22} />} title="Posting & Revenue">
            {permissions?.some((p) => p.formName === 'Lease Revenue' && p.canView) && (
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Revenue/Posting">Lease Revenue Posting</NavLink>
              </MenuItem>
            )}

            {/* {permissions?.some((p) => p.formName === 'Termination' && p.canView) && ( */}
            {/* <MenuItem icon={<MdCancel size={18} />}>
              <NavLink to="/Property/Management/Lease/Payment/Management">Manage Payment</NavLink>
            </MenuItem> */}
            {/* )} */}

            {/* <MenuItem icon={<MdOutlineUndo size={18} />}>
              <NavLink to="/Property/Management/Lease/Posting">Lease Posting</NavLink>
            </MenuItem> */}
          </SubMenu>

          {/* Inventory */}
          {permissions?.some((p) => p.formName === 'Inventory Update' && p.canView) && (
            <MenuItem icon={<MdOutlineInventory size={22} />}>
              <NavLink to="/Property/Management/Lease/Inventory/Update">Inventory Update</NavLink>
            </MenuItem>
          )}


          {/* {permissions?.some(p => p.formName === 'Inventory Update' && p.canView) && (
            <MenuItem icon={<MdOutlineInventory size={22} />}>
              <NavLink to="/Property/Management/Customer/Listing">
                Customer Management
              </NavLink>
            </MenuItem>
          )} */}
          <SubMenu icon={<IoReceiptOutline size={22} />} title="Reports">
            {/* {permissions?.some((p) => p.formName === 'Available Unit Report' && p.canView) && ( */}
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Reports/Occupancy">Available Units Report</NavLink>
              </MenuItem>
            {/* )} */}
            {/* {permissions?.some((p) => p.formName === 'Available Unit Report' && p.canView) && ( */}
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Reports/leaseStatment">Lease Statement Report</NavLink>
              </MenuItem>
            {/* )} */}
            {/* {permissions?.some((p) => p.formName === 'Tax Statement Report' && p.canView) && ( */}
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Reports/TaxStatement">Tax Statement Report</NavLink>
              </MenuItem>
            {/* )} */}
            {/* {permissions?.some((p) => p.formName === 'Tenant Invoice Report' && p.canView) && ( */}
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Reports/TenantInvoice">Tenant Invoice Report</NavLink>
              </MenuItem>
            {/* )} */}
            {/* {permissions?.some((p) => p.formName === 'Occupancy Report' && p.canView) && ( */}
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Reports/TenantOccupancy">Occupancy Report</NavLink>
              </MenuItem>
            {/* )} */}
            {/* {permissions?.some((p) => p.formName === 'Lease Outstanding Report' && p.canView) && (
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Reports/LeaseOutstanding">Lease Outstanding Report</NavLink>
              </MenuItem>
            )} */}
            {/* {permissions?.some((p) => p.formName === 'Month Wise Revenue Report' && p.canView) && ( */}
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Reports/MonthWiseRevenue">Month Wise Revenue</NavLink>
              </MenuItem>
            {/* )} */}
            {/* {permissions?.some((p) => p.formName === 'Unit Master List Report' && p.canView) && ( */}
              <MenuItem icon={<BsFillPostcardFill size={18} />}>
                <NavLink to="/Property/Management/Lease/Reports/UnitMasterList">Unit Master List Report</NavLink>
              </MenuItem>
            {/* )} */}
          </SubMenu>
        </Menu>
        <div onClick={handleToggle} className="sidebar-toggle-btn" style={{ left: collapsed ? '100px' : '300px' }}>
          <RxHamburgerMenu size={25} />
        </div>
      </ProSidebar>
    </div>
  );
};

export default PMSideBar;
